<ng-container *ngIf="groupedChatList.length > 0">
  <div class="position-relative booking-user-chat user-chat w-100 overflow-hidden minimal-border" id="users-chat">
    <div class="chat-scroll">
      <div class="chat-conversation p-3 p-lg-4 col-lg-6 mx-auto">
        <ul class="list-unstyled chat-conversation-list pt-0" id="users-conversation">
          @for (data of groupedChatList; track $index) { @if (data.isDateHeader) {
          <div class="d-flex justify-content-center chat-header-date">
            <span class="badge rounded-pill bg-primary-subtle text-primary fs-14" style="line-height: unset">
              {{ helper.moment(data.date).tz(helper.displayTimezone).format(helper.DATE_FORMAT.DD_MM_YY) }}
            </span>
          </div>
          } @else {
          <li
            class="chat-list"
            [ngClass]="data.type === helper.UserType.CUSTOMER || (chatType === helper.ChatType.DRIVER_MERCHANT_CHAT && data.type === helper.UserType.DRIVER) ? 'right' : 'left'"
          >
            <div class="conversation-list">
              <div class="chat-avatar">
                @if (data.type === helper.UserType.CUSTOMER) {
                <img
                  [src]="data.customerDetail?.imageUrl ? helper.imageUrl + data.customerDetail?.imageUrl : helper.DefaultImages.DefaultUserImage"
                  (error)="handleCustomerImageError($event, data)"
                  alt=""
                />
                } @else if (data.type === helper.UserType.DRIVER) {
                <img
                  [src]="data.confirmedDriver?.imageUrl ? helper.imageUrl + data.confirmedDriver?.imageUrl : helper.DefaultImages.DefaultUserImage"
                  (error)="handleDriverImageError($event, data)"
                  alt=""
                />
                } @else if (data.type === helper.UserType.MERCHANT) {
                <img
                  [src]="data.merchantDetail?.imageUrl ? helper.imageUrl + data.merchantDetail?.imageUrl : helper.DefaultImages.DefaultUserImage"
                  (error)="handleMerchantImageError($event, data)"
                  alt=""
                />
                }
              </div>
              <div class="user-chat-content">
                <div class="ctext-wrap">
                  <div class="ctext-wrap-content">
                    @switch (attachmentType(data)) { @case (AttachmentsType.IMAGE) {
                    <img
                      [src]="attachmentUrl(data.message)"
                      class="chat-attachment-image c-pointer"
                      alt="{{ attachmentName(data.message) }}"
                      loading="lazy"
                      (click)="openImageLightBox(attachmentUrl(data.message))"
                    />
                    } @case (AttachmentsType.VIDEO) {
                    <video class="chat-attachment-media" controls preload="metadata" [src]="attachmentUrl(data.message)"></video>
                    } @case (AttachmentsType.AUDIO) {
                    <audio class="chat-attachment-audio" controls preload="metadata" [src]="attachmentUrl(data.message)"></audio>
                    } @case (AttachmentsType.DOCUMENT) {
                    <a class="chat-attachment-file" [href]="attachmentUrl(data.message)" target="_blank" rel="noopener" [download]="attachmentName(data.message)">
                      <i class="ri-file-text-line align-middle me-1"></i>
                      <span class="text-break">{{ attachmentName(data.message) }}</span>
                    </a>
                    } @default {
                    <p class="mb-0 ctext-content">{{ data.message }}</p>
                    } }
                  </div>
                </div>
                <div class="conversation-name">
                  <small class="text-muted time">{{ helper.moment(data.createdAt).tz(helper.displayTimezone).format(helper.DATE_FORMAT.HH_MM_A) }}</small>
                </div>
              </div>
            </div>
          </li>
          } }
        </ul>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="groupedChatList.length === 0">
  <div class="py-4 text-center">
    <span>{{ "label-title.no-records-found" | translate }}</span>
  </div>
</ng-container>
